const passwordRules = [
  {
    text: 'An uppercase letter',
    name: 'containsUppercaseAlphabetical',
  },
  {
    text: 'A lowercase letter',
    name: 'containsLowercaseAlphabetical',
  },
  {
    text: 'A number',
    name: 'containsNumber',
  },
  {
    text: 'A symbol',
    name: 'containsSpecialChar',
  },
  {
    text: 'Minimum 8 characters',
    name: 'minLength8',
  },
];

export default passwordRules;



// WEBPACK FOOTER //
// ./src/config/passwordRules.js